import { render, staticRenderFns } from "./CaseTaskData.vue?vue&type=template&id=675dd9e6&scoped=true"
import script from "./CaseTaskData.vue?vue&type=script&lang=js"
export * from "./CaseTaskData.vue?vue&type=script&lang=js"
import style0 from "./CaseTaskData.vue?vue&type=style&index=0&id=675dd9e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675dd9e6",
  null
  
)

export default component.exports